var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tela-component',{attrs:{"title":"Formação de Carga"}},[_c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('v-card-text',[_c('v-data-table',{attrs:{"no-data-text":"Nenhuma formação de carga encontrada"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }